import React, { FC } from 'react';
import styles from './styles.module.css';

export interface SecretaryCardProps {
  title: string;
  subtitle?: string;
  backgroundColor?: string;
}

export const SecretaryCard: FC<SecretaryCardProps> = ({
  title,
  subtitle,
  backgroundColor = 'var(--service-menu-button-background)',
}) => {
  return (
    <div
      data-testid={title.toLowerCase().replace(/ /g, '-')}
      className={styles.card}
      style={{ backgroundColor }}
    >
      <h1 className={styles.title} title={title}>
        {title}
      </h1>
      {subtitle && (
        <p className={styles.subtitle} title={subtitle}>
          {subtitle}
        </p>
      )}
    </div>
  );
};
